import { useContext } from "react";
import { AlertContext } from "..";

export default function useAlert(){
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('[DEV]: useAlert must be used within AlertProvider');
  }
  return context;
};